import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import { GET_ALL_NOTIFICATIONS, READ_NOTIFICATION, RENEWAL_SYSTEM_NOTIFICATION, READ_NOTIFICATION_UPGRADE } from "@/utils/api-url";

export default class Notification extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"];
    this.description = params["grpId"] && params["grpId"]["description"] ||  params['description'] ||this.description || '';
    this.subject = params["grpId"] && params["grpId"]["subject"] || params['subject'] || this.subject || ''
  }

  static resourceName() {
    return "notification";
  }

  static index(params) {
    return apiDispatcher(GET_ALL_NOTIFICATIONS(params));
  }

  static readNotification(params) {
    return apiDispatcher(READ_NOTIFICATION(params))
  }

  static readNotificationUpgrade(params) {
    return apiDispatcher(READ_NOTIFICATION_UPGRADE(params))
  }

  static renewalSystemNotification(params) {
    return apiDispatcher(RENEWAL_SYSTEM_NOTIFICATION(params))
  }
}
